import { AccordionTheme } from '../../types';

export const ACCORDION_DEFAULT_THEME: AccordionTheme = {
    paddingX: 16,
    headerPaddingY: 16,
    chevronSize: 16,
    contentPaddingBottom: 16,
};
